var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTakt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.5C1 5.22386 1.22386 5 1.5 5H4.5C4.77614 5 5 5.22386 5 5.5V6.5C5 6.77614 4.77614 7 4.5 7H1.5C1.22386 7 1 6.77614 1 6.5V5.5Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.5C1 2.22386 1.22386 2 1.5 2H4.5C4.77614 2 5 2.22386 5 2.5V3.5C5 3.77614 4.77614 4 4.5 4H1.5C1.22386 4 1 3.77614 1 3.5V2.5Z",
    fill: "#000000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "#000000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTakt);
export default __webpack_public_path__ + "static/media/icon--takt.480181195168153f1a2558e844693c91.svg";
export { ForwardRef as ReactComponent };